module.exports = __webpack_public_path__ + "static/media/art29.82c69325.jpg";